import React from "react";

const Loading = () => {
  return (
    <p>
      Loading content...{" "}
      <img
        className="bear"
        src="https://www.how-to-draw-funny-cartoons.com/image-files/bear-cartoon-002.jpg"
        alt="bear"
      />{" "}
      with us
    </p>
  );
};

export default Loading;
